export enum InputType {
    Currency = 1,
    Numeric = 2,
    DateToolbar = 3,
}
